import * as React from 'react';
import { observer } from 'mobx-react';
import { RulesStores } from '../stores';
import { Button, Popconfirm, Table, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { Connection } from '../models';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';

type Props = RulesStores;

export const RDConnectionsList: React.FC<Props> = ({ RuleExternalConnections: store }) => {
    const columns: ColumnProps<Connection>[] = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            render: (id: string) => <span data-id-cells="Id">{id}</span>
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => {
                return a.name.localeCompare(b.name);
            },
            render: (name: string) => <span data-id-cells="Name">{name}</span>
        },
        {
            title: 'Connection Type',
            dataIndex: 'connectionType',
            key: 'connectionType',
            sorter: (a, b) => {
                return a.connectionType.localeCompare(b.connectionType);
            },
            render: (name: string) => <span data-id-cells="Connection Type">{name}</span>
        },
        {
            title: 'Actions',
            width: 200,
            render: (t: string, record: Connection) => {
                return (
                    <HasPermission
                        entityId={store?.currentProject?.id}
                        permissionClaim={AppPermissions.CanEditRefDataConnections}
                    >
                        <div className="row-actions-wrapper">
                            <Button
                                size="small"
                                type="link"
                                onClick={() => {
                                    store!.edit(record);
                                }}
                                data-id-cells="Edit connection"
                            >
                                <Tooltip title="Edit connection" placement="bottom">
                                    <i className="alpha-icon md edit-icon" />
                                </Tooltip>
                            </Button>
                            <Button
                                size="small"
                                type="link"
                                onClick={() => {
                                    store!.exportConnection(record.id);
                                }}
                                data-id-cells="Export"
                            >
                                <Tooltip title="Export" placement="bottom">
                                    <i className="alpha-icon md arrow-up" />
                                </Tooltip>
                            </Button>
                            <Popconfirm
                                title="Are you sure delete this task?"
                                onConfirm={() => store!.delete(record.id)}
                                okText="Yes"
                                cancelText="No"
                                id="data-id-popconfirm-box-DeleteConfirm"
                            >
                                <Button size="small" type="link" data-id-cells="Delete connection">
                                    <Tooltip title="Delete connection" placement="bottom">
                                        <i className="alpha-icon md delete-icon-red" />
                                    </Tooltip>
                                </Button>
                            </Popconfirm>
                        </div>
                    </HasPermission>
                );
            }
        }
    ];

    return (
        <Table
            data-id="table-RDConnection-List"
            rowKey="id"
            className="alpha-portal-table"
            columns={columns}
            dataSource={store!.connections}
            pagination={false}
        />
    );
};

export default observer(RDConnectionsList);
